import { sheetInchesNew, sheetPointsNew, sheetPixelsNew } from "common/utils/nominalNumbers";

// Scale factors

export const BROCHURE_ANNOTATION_SCALE = 0.5;
export const BROCHURE_SVG_SCALE = 0.5;

export const THREE_QUARTERS_INCH = sheetInchesNew(0.75);
export const ONE_INCH = sheetInchesNew(1);
export const ZERO_INCHES = sheetInchesNew(0);

export const ONE_POINT = sheetPointsNew(1);
export const ZERO_POINTS = sheetPointsNew(0);

export const ZERO_PIXELS = sheetPixelsNew(0);
export const ONE_PIXEL = sheetPixelsNew(1);
